import {isEmpty} from '@shared/helpers/lang'

import {initDetailByAPI} from '@web/actions/detail'
import makeSlice from '@web/slices/orderTotal/sliceMaker'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initDetailByAPI.fulfilled, (state, {payload}) => {
            const {
                pay: {
                    totalProductAmount,
                    deliveryFeeAmount,
                    deposits,
                    totalDiscountAmount,
                    liveDiscountAmount,
                    onePlusDiscountAmount,
                    sellerImmediateDiscountAmount,
                    sellerProductDiscountAmount,
                    sellerSubscriberDiscountAmount,
                    managerImmediateDiscountAmount,
                    managerProductDiscountAmount,
                    productDuplicateDiscountAmount,
                    multiplePurchaseDiscountAmount,
                    subscriptionDiscountAmount,
                    storeDiscountAmount,
                    deliveryFeeDiscountAmount,
                    escrowCommissionAmount,
                    escrowDeliveryCommissionAmount,
                    rentalSupplementProductPayAmount,
                    rentalPrePayAmount,
                    rentalOnetimeFees,
                    rentalSubscriptionRound,
                    rentalMonthlyAmount,
                    membershipDeliveryFeeDiscount,
                    promotionDiscountAmount,
                },
            } = payload.data
            state.amount = totalProductAmount
            state.deliveryFeeAmount = deliveryFeeAmount
            state.safetyPurchaseAmount = escrowCommissionAmount
            state.escrow = {
                productAmount: escrowCommissionAmount ?? 0,
                deliveryFeeAmount: escrowDeliveryCommissionAmount ?? 0,
            }
            if (!isEmpty(deposits)) {
                state.cupDeposit = deposits.reduce(
                    (acc, {depositType, depositAmount}) => {
                        if (depositType === 'SINGLE_USE_CUP') {
                            return {
                                ...acc,
                                disposable: depositAmount ?? 0,
                            }
                        }
                        if (depositType === 'REUSABLE_CUP') {
                            return {
                                ...acc,
                                reusable: depositAmount ?? 0,
                            }
                        }
                        return acc
                    },
                    {
                        /** 일회용 컵보증금 */
                        disposable: 0,
                        /** 재사용 컵보증금 */
                        reusable: 0,
                    },
                )

                // 컵보증금 외에는 보증금이 여러 개 내려오는 케이스가 없음
                const selectedDeposit = deposits.find(
                    (deposit): deposit is {depositAmount: number; depositType: 'COOL_BAG' | 'PLASTIC_BAG'} =>
                        deposit.depositType === 'COOL_BAG' || deposit.depositType === 'PLASTIC_BAG',
                )
                if (selectedDeposit) {
                    state.deposit = {
                        type: selectedDeposit.depositType,
                        amount: selectedDeposit.depositAmount ?? 0,
                    }
                }
            }

            state.discount = {
                totalDiscountAmount,
                liveAmount: liveDiscountAmount,
                onePlusAmount: onePlusDiscountAmount,
                sellerImmediateDiscountAmount,
                sellerProductDiscountAmount,
                sellerSubscriberDiscountAmount,
                managerImmediateDiscountAmount,
                managerProductDiscountAmount,
                productDuplicateDiscountAmount,
                multiplePurchaseDiscountAmount,
                subscriptionDiscountAmount,
                storeDiscountAmount,
                deliveryFeeDiscountAmount,
                isArrivalGuaranteeDiscount: membershipDeliveryFeeDiscount,
                promotionDiscountAmount,
            }
            state.discountAmount = totalDiscountAmount
            state.productDiscountAmount = totalDiscountAmount - deliveryFeeDiscountAmount
            state.deliveryDiscountAmount = deliveryFeeDiscountAmount
            if (
                rentalSupplementProductPayAmount ||
                rentalPrePayAmount ||
                !isEmpty(rentalOnetimeFees) ||
                rentalSubscriptionRound ||
                rentalMonthlyAmount
            ) {
                state.rental = {
                    supplementProductPayAmount: rentalSupplementProductPayAmount,
                    prePayAmount: rentalPrePayAmount,
                    onetimePayAmounts: rentalOnetimeFees?.map(({onetimeFeeAmount, onetimeFeeName}) => ({
                        amount: onetimeFeeAmount,
                        name: onetimeFeeName,
                    })),
                    subscriptionRound: rentalSubscriptionRound,
                    monthlyAmount: rentalMonthlyAmount,
                }
            }
        })
    },
})

export default slice.reducer
